module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-0.60c06806.svg";